import React from 'react';
import styles from './Results.module.css';
import Card from '../UI/Card';
import Button from '../UI/Button';
import { formatCurrency } from '../../utils/formatCurrency';
import Recommendation from './Recommendation';
import ReactGA from "react-ga4";

const Results = ({ data, onReset }) => {
  ReactGA.initialize("G-1HWZHF4TVV");
  ReactGA.event({
    category: "event",
    action: "page_view",
    label: "2Dg_CN3xsY8cELzJg_QC", // optional
    value: 1, // optional, must be a number
  });
  const {
    incomeBased,
    needBased,
    rekomendasiUP,
    rekomendasiProduk,
    estimasiPremiRendah,
    estimasiPremiTinggi,
    ringkasan
  } = data;
  

  return (
    <div className={styles.results}>
      <Card>
        <h2 className={styles.title}>📊 Hasil Analisis Kebutuhan Asuransi Jiwa</h2>
        
        <div className={styles.summary}>
          <div className={styles.summaryItem}>
            <span className={styles.summaryLabel}>Nama Klien:</span>
            <span className={styles.summaryValue}>{data.formData?.nama}</span>
          </div>
          <div className={styles.summaryItem}>
            <span className={styles.summaryLabel}>Tanggal Analisis:</span>
            <span className={styles.summaryValue}>{new Date().toLocaleDateString('id-ID')}</span>
          </div>
        </div>

        <div className={styles.resultCards}>
          <div className={styles.resultCard}>
            <h3>Metode Income-Based</h3>
            <div className={styles.resultValue}>{formatCurrency(incomeBased)}</div>
            <p className={styles.resultDesc}>Berdasarkan penghasilan tahunan x faktor usia</p>
          </div>

          <div className={styles.resultCard}>
            <h3>Metode Need-Based</h3>
            <div className={styles.resultValue}>{formatCurrency(needBased)}</div>
            <p className={styles.resultDesc}>Berdasarkan kebutuhan riil keluarga</p>
          </div>

          <div className={`${styles.resultCard} ${styles.recommended}`}>
            <h3>🎯 UANG PERTANGGUNGAN REKOMENDASI</h3>
            <div className={styles.recommendedValue}>{formatCurrency(rekomendasiUP)}</div>
          </div>
        </div>

        <div className={styles.premiSection}>
          <h3>Estimasi Premi Tahunan (Term Life)</h3>
          <div className={styles.premiGrid}>
            <div>
              <span className={styles.premiLabel}>Estimasi Rendah:</span>
              <span className={styles.premiValue}>{formatCurrency(estimasiPremiRendah)}</span>
            </div>
            <div>
              <span className={styles.premiLabel}>Estimasi Tinggi:</span>
              <span className={styles.premiValue}>{formatCurrency(estimasiPremiTinggi)}</span>
            </div>
          </div>
        </div>

        <Recommendation 
          produk={rekomendasiProduk}
          usia={ringkasan.usia}
          up={rekomendasiUP}
        />

        <div className={styles.detailSection}>
          <h3>Detail Perhitungan Need-Based</h3>
          <table className={styles.detailTable}>
            <tbody>
              <tr>
                <td>Pengeluaran Bulanan</td>
                <td>{formatCurrency(ringkasan.pengeluaranBulanan)}</td>
              </tr>
              <tr>
                <td>Dana Masa Depan</td>
                <td>{formatCurrency(ringkasan.danaMasaDepan)}</td>
              </tr>
              <tr>
                <td>Total Kewajiban</td>
                <td>{formatCurrency(ringkasan.totalKewajiban)}</td>
              </tr>
              <tr>
                <td>Total Aset Lancar</td>
                <td>{formatCurrency(ringkasan.totalAset)}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className={styles.buttonGroup}>
          <Button variant="secondary" onClick={onReset}>
            🔄 Hitung Ulang
          </Button>
          <Button variant="primary" onClick={() => window.print()}>
            🖨️ Cetak Hasil
          </Button>
        </div>

        <div className={styles.disclaimer}>
          <p>*Hasil ini adalah estimasi berdasarkan data yang Anda berikan. Untuk analisis lebih detail, konsultasikan dengan perencana keuangan profesional.</p>
        </div>
      </Card>
    </div>
  );
};

export default Results;